
import { defineComponent, markRaw, PropType, shallowRef } from 'vue';
import GridRow from '@/components/2.6/GridRow.vue';
import GridRowData from '@/models/grid/GridRowData';

import DataPreferenceSettings from '@/components/2.6/modals/DataPreferenceSettings.vue';
import ImageViewer from '@/components/2.6/modals/ImageViewer.vue';
import { FieldIds } from '@/constants/FieldIds';

export default defineComponent({
    components: {
        GridRow,
        DataPreferenceSettings
    },
    props: {
        rowDatas: {
            type: Object as PropType<GridRowData[]>,
            required: true
        }
    },
    data() {
        return {
            modalDataPreferenceSettings: {
                show: false,
                component: shallowRef(DataPreferenceSettings),
                defaultTabIdx: 0,
                hiddenTabIdx: [] as number[],
                fieldId: 0
            },
            modalImageViewer: {
                show: false,
                component: markRaw(ImageViewer),
                imagePath: 0
            }
        };
    },
    mounted() {
        (this as any).eventBus.on('launchDataPreferenceSettingsModal', (e: any) => {
            this.modalDataPreferenceSettings.show = true;
            this.modalDataPreferenceSettings.defaultTabIdx = e.defaultTabIdx || 0;
            this.modalDataPreferenceSettings.fieldId = e.fieldId || 0;
            // Hide Formatting Rules tab if Property Photo row is selected
            this.modalDataPreferenceSettings.hiddenTabIdx = e.fieldId === FieldIds.CompPhoto ? [1] : [];
        });
        (this as any).eventBus.on('launchFieldRulesModal', (e: any) => {
            this.modalDataPreferenceSettings.show = true;
            this.modalDataPreferenceSettings.defaultTabIdx = e.defaultTabIdx || 0;
            this.modalDataPreferenceSettings.fieldId = e.fieldId || 0;
        });
        (this as any).eventBus.on('launchImageViewerModal', (e: any) => {
            this.modalImageViewer.show = true;
            this.modalImageViewer.imagePath = e.imagePath;
        });
    },
    computed: {
        rows(): GridRowData[] {
            return this.rowDatas;
        }
    }
});
